// extracted by mini-css-extract-plugin
export default {"root":"CaseDetailsPlaceholder_root__k7GW1"};